import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4265d59e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qr-contents" }
const _hoisted_2 = { class: "qr-contents-close" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qr-contents-top" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-18 text-weight-500 text-white" }, "旧出退勤リーダー"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-size-14 text-white" }, "\n        スキャンするにはQRコードをフレーム内に合わせてください\n      ")
], -1))
const _hoisted_4 = { class: "qr-contents-middle" }
const _hoisted_5 = { class: "qr-contents-bottom" }
const _hoisted_6 = { class: "text-size-14 text-white" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AttendanceCodeForm = _resolveComponent("AttendanceCodeForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterLink, { to: { name: 'ApplicationsList' } }, {
        default: _withCtx(() => [
          _createVNode(_component_FeatherIcon, {
            icon: "x",
            stroke: "white"
          })
        ], undefined, true),
        _: 1
      })
    ]),
    _createTextVNode(),
    _hoisted_3,
    _createTextVNode(),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.qrContentsFrameClass)
      }, null, 2)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, [
        _createTextVNode("\n        QRコードが読み取れない場合は\n        "),
        _createVNode(_component_RouterLink, {
          class: "link",
          to: {
            name: 'QrScannerWeb',
            query: _ctx.$route.query
          }
        }, {
          default: _withCtx(() => [
            _createTextVNode("新しい出退勤リーダー")
          ], undefined, true),
          _: 1
        }, 8, ["to"]),
        _createTextVNode("\n        を使うか、事業所担当者に4桁のコードを確認して以下に入力してください\n      ")
      ]),
      _createTextVNode(),
      _createVNode(_component_AttendanceCodeForm, {
        workStatus: _ctx.workStatus,
        onSubmit: _ctx.submit
      }, null, 8, ["workStatus", "onSubmit"])
    ]),
    _createTextVNode(),
    _hoisted_7
  ]))
}